/*
  MWG Apparel - product card video autoplay
  --------------------------------------------------------------
  Desktop (fine pointer): plays on card hover / keyboard focus.
  Touch: plays the single card closest to the centre of the
  viewport, one at a time, never a whole grid at once.

  Skips autoplay entirely when the visitor has reduced-motion on,
  has Save Data enabled, or is on a 2G/3G connection.
*/
(function () {
  if (window.__mwgCardVideoInit) return;
  window.__mwgCardVideoInit = true;

  var SELECTOR = '.mwg-card-video';
  var PLAY_THRESHOLD = 0.6;

  var current = null;
  var io = null;
  var ratios = new Map();

  function motionAllowed() {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    } catch (e) {}

    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData) return false;
      var slow = ['slow-2g', '2g', '3g'];
      if (slow.indexOf(conn.effectiveType) !== -1) return false;
    }
    return true;
  }

  var canHover = false;
  try {
    canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  } catch (e) {}

  function prep(v) {
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
  }

  function play(v) {
    if (!v) return;
    if (current && current !== v) stop(current);
    current = v;
    v.style.opacity = '1';
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        v.style.opacity = '0';
      });
    }
  }

  function stop(v) {
    if (!v) return;
    v.style.opacity = '0';
    try {
      v.pause();
      v.currentTime = 0;
    } catch (e) {}
    if (current === v) current = null;
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      ratios.set(entry.target, entry.intersectionRatio);
    });

    var best = null;
    var bestRatio = 0;

    ratios.forEach(function (ratio, el) {
      if (!el.isConnected) {
        ratios.delete(el);
        return;
      }
      if (ratio > bestRatio) {
        bestRatio = ratio;
        best = el;
      }
    });

    if (best && bestRatio >= PLAY_THRESHOLD) {
      if (current !== best) play(best);
    } else if (current) {
      stop(current);
    }
  }

  function ensureObserver() {
    if (io || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(onIntersect, {
      threshold: [0, 0.25, 0.5, 0.6, 0.75, 0.9, 1],
      rootMargin: '-5% 0px -5% 0px'
    });
  }

  function bind(v) {
    if (!v || v.dataset.mwgBound === '1') return;
    v.dataset.mwgBound = '1';
    prep(v);

    if (canHover) {
      var card = v.closest('.card-wrapper') || v.closest('.card') || v.parentElement;
      if (!card) return;
      card.addEventListener('mouseenter', function () { play(v); });
      card.addEventListener('mouseleave', function () { stop(v); });
      card.addEventListener('focusin', function () { play(v); });
      card.addEventListener('focusout', function () { stop(v); });
    } else {
      ensureObserver();
      if (io) {
        ratios.set(v, 0);
        io.observe(v);
      }
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), bind);
  }

  function watch() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SELECTOR)) {
            bind(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (!motionAllowed()) return;
    scan();
    watch();

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && current) stop(current);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();